

//import React from "react";
import "./ReportFirstSection.css";

export default function ReportFirstSection({res}) {
    //const res=JSON.parse(localStorage.getItem("scorecardData"))
   const score=res?.totalScore??0
  const maxScore = 600;
  const percentage = (score / maxScore) * 100;

  // Dynamic score color logic
  const getScoreColor = (score, isDarkMode = false) => {
  if (score >= 500) return isDarkMode ? "#2fe88b" : "#18a558";
  if (score >= 400) return isDarkMode ? "#9af0c2" : "#7fde9a";
  if (score >= 300) return isDarkMode ? "#ffd88a" : "#ffc66a";
  return isDarkMode ? "#ff8f8f" : "#ff6b6b";
};

 // Detect if dark mode is active
  const isDarkMode = document.body.classList.contains("dark-mode");
  const strokeColor = getScoreColor(score, isDarkMode);




  return (
    <div className="reportfirstsection">
      <div className="report-card">

        <div className="report-row-idea">

          {/* LEFT COLUMN */}
          <div className="left-col">
            <img className="logo" src="/image/logo.png" alt="Logo" />
          </div>

          {/* MIDDLE COLUMN */}
          <div className="middle-col">
            <h1 className="report-A-title">MARSMATE VALIDATION AUTOMATION ENGINE</h1>
            <div className="report-details">
              <p>Validation as a Service, Plug & Play Tech Platform, Mind Mapping, AI-Based Analytics IDEA VALIDATION</p>
              <p>REF ID: {res?.userId??"87u876ty6"}</p>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="right-col">
            <div className="score-ring">
              <svg viewBox="0 0 36 36" className="circular-chart">
                {/* background circle */}
                <path
                  className="circle-bg"
                  d="M18 2a16 16 0 1 1 0 32 16 16 0 1 1 0-32"
                />
                {/* dynamic circle */}
                <path
                  className="circle"
                  stroke={strokeColor}
                  strokeDasharray={`${percentage}, 100`}
                  d="M18 2a16 16 0 1 1 0 32 16 16 0 1 1 0-32"
                />
              </svg>
              {/* score text */}
              <div className="score-text">{score}</div>
            </div>

            {/* user info */}
            <div className="user-info">
              <p className="user-logo">{res.companyName[0]}</p>
              <p className="company-namer1">{res.companyName}</p>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}
